import script from "./AccountStatusCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountStatusCard.vue?vue&type=script&setup=true&lang=js"

import "./AccountStatusCard.vue?vue&type=style&index=0&id=15114fbe&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15114fbe"]])

export default __exports__